

































import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import RoleFormComponent from "./RoleFormDialog.vue";
import User, { countUserWithRole, Role } from "@/data/models/User";
import {
  getRoleActive,
  getRoleDescription,
  getRoleId,
  getRoleLabel,
  RoleSettings,
} from "@/data/models/RoleSettings";

@Component({
  components: {
    "role-form": RoleFormComponent,
  },
})
export default class RoleItemComponent extends Vue {
  @Prop() elevation!: number;
  @Prop() role!: Role;
  @Prop() roleSettings!: RoleSettings;
  @Prop() users!: User[];

  @Ref("roleForm")
  roleFormDialog!: RoleFormComponent;

  get roleLabel() {
    return getRoleLabel(this.role, this);
  }

  get roleId() {
    return getRoleId(this.role);
  }

  get countUserWithRole() {
    return countUserWithRole(this.role);
  }

  get roleActive() {
    return getRoleActive(this.role, this);
  }

  get roleDescription() {
    return getRoleDescription(this.role, this);
  }

  async openDetails() {
    this.roleFormDialog.show(
      this.roleLabel,
      this.roleDescription,
      this.roleActive
    );
  }
}
